import React from "react";
import Select from "react-select";
import { PrimaryButton, SecondaryButton } from "@loanbossinc/component-library";
import { Checkbox } from "@material-ui/core";
import styled from "styled-components/macro";

import { CAMPAIGN_VALUE_TYPE } from "../constants";
import { EdcEmailTemplate } from "../EdcEmailTemplate";

import { PrepaymentTemplate, ValuationSensitivityTemplate } from "./Templates";

const LeftSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1em;
`;

const StyledSelect = styled(Select)`
  width: 100%;
  height: 40px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  color: #5F6368;
  && div:first-child {
    border-radius: 8px;
  }
  && div > div:nth-child(2) > span {
    display: none;
  }
`;

const StyledTextInput = styled.input`
  // 12px is 8px left padding, 2 x 1px border widths, 2px right padding
  width: calc(513px - 12px);
  height: calc(40px - 4px);
  background: #FFFFFF;
  border: 1px solid #DADCE0;
  border-radius: 8px;
  padding-left: 8px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  color: #5F6368;
`;

const StyledSecondaryButton = styled(SecondaryButton)`&&& {
  && > span:first-child {
    font-family: Work Sans;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
  }
}`;

const StyledPrimaryButton = styled(PrimaryButton)`&&& {
  && > span:first-child {
    font-family: Work Sans;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
  }
}`;

const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 1em;
  gap: 1em;
  justify-content: space-between;
  width: 1115px;
`;

const CcCheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5em;
  align-items: center;
  && > span {
    font-family: Metropolis;
    font-size: 14px;
    font-weight: 400;
    line-height: 15px;
  }
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1em;
`;

const LabelInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.5em;
  width: 513px;
`;

const StyledLabel = styled.div`
  font-family: Metropolis;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
  color: #102F54BF;
`;

export const EdcEmailComposition = ({
  handleComposeEmailSaveAndExitClicked,
  handleComposeEmailSaveAndContinueClicked,
  company,
  brokerEmail,
  campaignType,
  email,
  setEmail,
  contactOptions
}) => {
  const { primaryColor, secondaryColor } = company;
  const Template = () => (CAMPAIGN_VALUE_TYPE.PREPAYMENT === campaignType ?
    <PrepaymentTemplate primaryColor={primaryColor} secondaryColor={secondaryColor} /> :
    <ValuationSensitivityTemplate primaryColor={primaryColor} secondaryColor={secondaryColor} />
  );

  const handleSubjectInput = ({ target }) => {
    const newEmail = { ...email };
    newEmail.subject = target.value;
    setEmail(newEmail);
  };

  const handleContactSelect = ({ value }) => {
    const newEmail = { ...email };
    newEmail.from = value;
    setEmail(newEmail);
  };

  const handleCcCheckboxSelect = () => {
    const newEmail = { ...email };
    newEmail.isCcBrokerIncluded = !newEmail.isCcBrokerIncluded;
    setEmail(newEmail);
  };

  return (
    <>
      <TopContainer>
        <LeftSectionWrapper>
          <LabelInputWrapper>
            <StyledLabel>From</StyledLabel>
            <StyledSelect
              options={contactOptions}
              styles={{ menu: provided => ({ ...provided, zIndex: 5 }) }}
              value={contactOptions.filter(option => option.value === email?.from)}
              onChange={handleContactSelect}
              placeholder=""
            />
          </LabelInputWrapper>
          <LabelInputWrapper>
            <StyledLabel>Subject</StyledLabel>
            <StyledTextInput
              onInput={handleSubjectInput}
              value={email?.subject}
            />
          </LabelInputWrapper>
          <CcCheckboxWrapper>
            <Checkbox
              checked={email?.isCcBrokerIncluded}
              onChange={handleCcCheckboxSelect}
            />
            <span>CC Broker Contacts</span>
          </CcCheckboxWrapper>
        </LeftSectionWrapper>
        <ButtonsWrapper>
          <StyledSecondaryButton
            onClick={handleComposeEmailSaveAndExitClicked}
            label="Save and exit"
            style={{ width: "180px", height: "36px" }}
          />
          <StyledPrimaryButton
            onClick={handleComposeEmailSaveAndContinueClicked}
            label="Save and continue"
            style={{ width: "180px", height: "36px" }}
          />
        </ButtonsWrapper>
      </TopContainer>
      <EdcEmailTemplate
        companyName={company?.name ?? "company"}
        companyLogo={company?.logoImage ?? ""}
        companyPrimaryColor={company?.primaryColor ?? "005AA9"}
        companySecondaryColor={company?.secondaryColor ?? "0F9AD6"}
        deal={null}
        brokerEmail={brokerEmail}
        template={() => <Template />}
        setEmail={setEmail}
        email={email}
      />
    </>
  );
};
